import { FeatureName } from '@app/core/interfaces/c5/feature-name';
import { EnterpriseOption } from '@app/core/interfaces/enterprise-option';
import { ServiceUser } from '@app/core/interfaces/service-user';
import { checkForFeature } from '@app/utils/feature/check-for-feature';

/**
 * Check if pcr is enabled for a queue based on the enterprise option CallRecPermanentFeatures and
 * the service user of the queue.
 *
 * @param option CallRecPermanentFeature option
 * @param user ServiceUser of queue
 */
export function pcrIsEnabled(option: EnterpriseOption | undefined, user: ServiceUser) {
  return option?.available > 0 && checkForFeature(user.features ?? [], FeatureName.VOICE_RECORDING).exists;
}
